import { render, staticRenderFns } from "./PointProgramsEditClients.vue?vue&type=template&id=6a65a16a&scoped=true&"
import script from "./PointProgramsEditClients.vue?vue&type=script&lang=js&"
export * from "./PointProgramsEditClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a65a16a",
  null
  
)

export default component.exports